<template>
  <div v-if="page.service" ref="page_service" class="page page-white page-service">
    <div class="container">
      <div v-html="page.service.text_lead" class="lead lead-intro col-md-12"/>

      <div class="col-md-12 col-service col-service-first">
        <h1>{{ page.service.title }}</h1>
      </div>

      <div ref="space" class="col-md-12 col-service col-service-space">  
        <div v-html="page.service.text_main_title" class="font-grotesque"/>
        <div class="col-service-text" v-html="page.service.text_main_dark"/>
        <Space v-if="!mobile" :class="['col-service-animation', {'col-service-animation-active': isSpace}]" :inViewport="isInViewport && !firstVisitAnimation"/>
      </div>

      <div ref="hulk" class="col-md-12 col-service col-service-hulk">
        <div class="font-grotesque" v-html="page.service.text_law_title"/>
        <Hulk v-if="!mobile" :class="['col-service-animation', {'col-service-animation-active': isHulk}]" :inViewport="isInViewport && !firstVisitAnimation"/>
        <div class="col-service-text" v-html="page.service.text_law_dark"/>
      </div>

      <div ref="parachute" class="col-md-12 col-service col-service-parachute">
        <div class="font-grotesque" v-html="page.service.text_corporate_title"/>
        <div class="col-service-text" v-html="page.service.text_corporate_dark"/>
        <Parachute v-if="!mobile" :class="['col-service-animation', {'col-service-animation-active': isParachute}]" :inViewport="isInViewport && !firstVisitAnimation"/>
      </div>

      <div ref="cubes" class="col-md-12 col-service col-service-cubes">
        <div class="font-grotesque" v-html="page.service.text_actives_title"/>
        <div class="col-service-text" v-html="page.service.text_actives_dark"/>
        <Cubes v-if="!mobile" :class="['col-service-animation', {'col-service-animation-active': isCubes}]" :inViewport="isInViewport && !firstVisitAnimation"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Parachute from '@/components/Animation/Parachute';
import Cubes from '@/components/Animation/Cubes';
import Space from '@/components/Animation/Space';
import Hulk from '@/components/Animation/Hulk';

export default {
  name: 'serviceAnimation',
  components: {
    Parachute,
    Cubes,
    Space,
    Hulk,
  },
  computed: mapGetters({
    firstVisitAnimation: 'firstVisitAnimation',
    globalVisibility: 'globalVisibility',
    mobile: 'mobile',
    page: 'page',
  }),
  props: ['view'],
  data() {
    return {
      isInViewport: false,
      isSpace: false,
      isHulk: false,
      isParachute: false,
      isCubes: false,
    };
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener('scroll', this.checkViewport);
    }, 5000);
  },
  methods: {
    checkViewport() {
      if (this.$refs.page_service) {
        const parent = this.$refs.page_service.parentNode;
        if (parent) {
          this.isInViewport = parent.parentNode.classList.contains('in-viewport');
        }
      }

      this.isSpace = this.isElementInViewport(this.$refs.space);
      this.isHulk = this.isElementInViewport(this.$refs.hulk);
      this.isParachute = this.isElementInViewport(this.$refs.parachute);
      this.isCubes = this.isElementInViewport(this.$refs.cubes);
    },

    isElementInViewport(ref) {
      const delta = window.innerHeight / 20;
      const rect = ref ? ref.getBoundingClientRect() : {};
      return rect.bottom > 0
        && rect.right > 0
        && rect.top - delta < (window.innerHeight || document.documentElement.clientHeight)
        // && rect.top > -delta
        && rect.left < (window.innerWidth || document.documentElement.clientWidth);
    },
  },
};
</script>

<style>
  .page-theme.in-viewport .page-white.page-service{
    .col-service-animation{
      transition: all .7s ease-in-out;
      transform-origin: center center;
      /*transform: scale(0.2);*/
      visibility: hidden;
      overflow: hidden;
      opacity: 0 !important;

      &-active{
        /*transform: scale(1);*/
        visibility: visible;
        @media (min-width: $mediaMob) {
          opacity: 1 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ServiceAnimation.vue